import { accountsAuthRequest } from "src/engine/modules/authRequest"
// Спека https://next.stoplight.io/infotech-group/accounts-admin/version%2F1.0/main.hub.yml?view=/admin-api/user
// Реализовывать другие методы по необходимости

export const getCurrentUser = () =>
  accountsAuthRequest({ url: `/users/current` })
